import type { IdentityAssessment, ResolutionGroup } from '@/services/api/entity-resolution-groups'
import { minimumGroupSimilarity } from './groupFormat'

export const IDENTITY_FIELDS = [
  'dob',
  'national_id',
  'registration_number',
  'tax_id',
  'vat_number',
] as const

export function identityFieldKey(field: string): string {
  const known = IDENTITY_FIELDS.some(value => value === field)
  return `resolutionIdentity.fields.${known ? field : 'other'}`
}

export function identityRequiresReview(assessment: IdentityAssessment | undefined): boolean {
  return assessment?.status === 'conflict' || assessment?.status === 'review'
}

export function exactGroupEligible(group: ResolutionGroup): boolean {
  return minimumGroupSimilarity(group) === 1 && !identityRequiresReview(group.identityAssessment)
}
